import { supabase } from "./supabase";

/** Uploads a file to `<bucket>/<uid>/<timestamp>-<name>` and returns its public URL. */
export async function uploadUserFile(
  bucket: string,
  uid: string,
  file: File,
): Promise<string> {
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
  const path = `${uid}/${Date.now()}-${safeName}`;
  const { error } = await supabase.storage.from(bucket).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });
  if (error) throw error;
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
}

/** Removes an object given its public URL (parses bucket + path back out). */
export async function removeByPublicUrl(bucket: string, publicUrl: string): Promise<void> {
  const marker = `/object/public/${bucket}/`;
  const idx = publicUrl.indexOf(marker);
  if (idx === -1) return;
  const path = publicUrl.slice(idx + marker.length);
  await supabase.storage.from(bucket).remove([decodeURIComponent(path)]);
}
